import React from "react";
import TableNotifications from "../../components/TableNotifications/TableNotifications";
import { ToastContainer } from "react-toastify";

const Notifications = () => {
  return (
    <div>
      <div className="p-3">
        <ToastContainer />
      </div>
      <div className="pt-[80px] md:pt-0 px-2 md:px-6 m-2 md:m-10 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Lista e Njoftimeve</p>
        <TableNotifications />
      </div>
    </div>
  );
};

export default Notifications; 